import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@approot/shared';
import { CurrencyPairsComponent } from './currency-pairs/currency-pairs.component';
import { CutoffsComponent } from './cutoffs/cutoffs.component';
import { FixingSourcesComponent } from './fixing-sources/fixing-sources.component';
import { TradeStatusComponent } from './trade-status/trade-status.component';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [
    CurrencyPairsComponent,
    FixingSourcesComponent,
    CutoffsComponent,
    TradeStatusComponent
  ],
  exports: [
    CurrencyPairsComponent,
    FixingSourcesComponent,
    CutoffsComponent,
    TradeStatusComponent
  ]
})
export class DisplayDefinitionsModule {}
